import { render } from "./SendMes.vue?vue&type=template&id=4d5e8630&scoped=true"
import script from "./SendMes.vue?vue&type=script&lang=js"
export * from "./SendMes.vue?vue&type=script&lang=js"

import "./SendMes.vue?vue&type=style&index=0&id=4d5e8630&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5e8630"]])

export default __exports__